import React, { useMemo } from 'react';
import { Modal, ModalContent, ModalCloseButton } from '../common';
import { Heading } from '../common/Typography';
import { getPlayerFullName } from '../../utils/playerUtils';
import { getEligiblePool } from '../../utils/pegBoard';
import { PegBoardPickForm } from './PegBoardPickPanel';

/**
 * Peg Board pick modal for empty playing/upcoming courts.
 */
const PegBoardPickModal = ({
  isOpen,
  onClose,
  waitingList = [],
  selectionWindow = 6,
  playersById = {},
  occupiedIds = [],
  occupiedPlayers = [],
  currentUserId = null,
  isSessionHost = false,
  onConfirm,
  confirming = false,
  matchHistory = [],
}) => {
  const pool = useMemo(
    () => getEligiblePool(waitingList, selectionWindow),
    [waitingList, selectionWindow]
  );
  const picker = playersById[pool.pickerId];
  const pickerName = picker ? getPlayerFullName(picker) : 'Next player';

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent size="medium" padding={false} className="flex min-h-0 flex-col overflow-hidden">
        <div className="flex shrink-0 items-start justify-between gap-3 border-b border-border-medium px-4 py-3 sm:px-6">
          <Heading level={2} className="min-w-0 pr-2 text-lg sm:text-xl">
            {pool.canPick ? `${pickerName} is up to pick` : 'Peg Board pick'}
          </Heading>
          <ModalCloseButton onClose={onClose} className="sticky top-0" />
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-4 py-4 sm:px-6">
          <PegBoardPickForm
            waitingList={waitingList}
            selectionWindow={selectionWindow}
            playersById={playersById}
            occupiedIds={occupiedIds}
            occupiedPlayers={occupiedPlayers}
            currentUserId={currentUserId}
            isSessionHost={isSessionHost}
            onConfirm={onConfirm}
            confirming={confirming}
            onPlaced={onClose}
            showHeader={false}
            matchHistory={matchHistory}
          />
        </div>
      </ModalContent>
    </Modal>
  );
};

export default PegBoardPickModal;
